
export async function getCurrentUser() {
    return firebase.auth().currentUser;
}

export async function addDocument(collectionPath, document) {
    const docRef = await firebase.firestore().collection(collectionPath).add(document);
    return docRef.id;
}

export async function updateDocument(collectionPath, docId, document) {
    document.id = docId;
    return await firebase.firestore().collection(collectionPath).doc(docId).set(document, { merge: true });
}

export async function deleteDocument(collectionPath, docId) {
    return await firebase.firestore().collection(collectionPath)
        .doc(docId)
        .delete();
}

function convertDates(data) {
    data.updatedAt = convertUnixTimeToFBTimestamp(data.updatedAt);
    data.createdAt = convertUnixTimeToFBTimestamp(data.createdAt);
    data.closedAt = convertUnixTimeToFBTimestamp(data.closedAt);
    return data;
}

function convertUnixTimeToFBTimestamp(unixString) {
    if (!unixString) return unixString;
    
    if (typeof unixString != 'string') {
        // This is already a fb date object
        return unixString;
    }
    // console.log(`converting timestamp: ${unixString}`)
    return { seconds: parseInt(unixString) };
}

export async function listenToDocument(collectionName, docId, onSnapshot) {
    return new Promise(async (resolve, reject) => {
        const unsubscribe = await firebase.firestore()
            .collection(collectionName)
            .doc(docId)
            .onSnapshot(async (doc) => {
                if (!doc.exists) {
                    return onSnapshot(null);
                } else {
                    const data = convertDates(doc.data());
                    
                    return onSnapshot(data);
                }
            }, reject);
        resolve(unsubscribe);
    })
}

function mapFilters(collection, filters) {
    for (let filter of filters) {
        if (filter[0] == "where") {
            collection = collection.where(filter[1], filter[2], filter[3])
        } else if (filter[0] == "orderBy") {
            collection = collection.orderBy(filter[1], filter[2])
        } else if (filter[0] = 'limit') {
            collection = collection.limit(filter[1])
        }
    }
    return collection;
}

export async function getDocument(collectionPath, docId) {
    const snap = await firebase.firestore().collection(collectionPath).doc(docId).get();
    if (!snap.exists) return null;
    let data = snap.data();
    data.id = snap.id;
    return data;
}

export async function getCollection(collectionName, filters) {
    let collection =
        firebase.firestore()
            .collection(collectionName);

    collection = mapFilters(collection, filters);
    const snapshot = await collection.get();
    let docs = [];
    if (snapshot.docs) {
        snapshot.docs.forEach(doc => {
            let data = doc.data();
            data.id = doc.id;
            docs.push(data);
        })
    }
    return docs;
}

export async function listenToCollection(collectionName, filters, onSnapshot) {
    return new Promise(async (resolve, reject) => {
        let collection =
            firebase.firestore()
                .collection(collectionName);
        collection = mapFilters(collection, filters);

        const unsubscribe = await collection.onSnapshot((querySnapshot) => {
            if (querySnapshot.docs) {
                let docs = [];
                querySnapshot.forEach(function (doc) {
                    let data = doc.data();
                    data.id = doc.id;
                    docs.push(data);
                });
                onSnapshot(docs);
            } else {
                onSnapshot(null);
            }
        }, reject);
        resolve(unsubscribe);
    })
}

export async function callable(functionName, payload) {
    var func = firebase.functions().httpsCallable(functionName);
    const payloadObj = {
        data: payload,
        client: "web",
    };
    return await func(payloadObj);
}

export async function removeListener(unsubscribeFunction) {
    await unsubscribeFunction();
}

export function serverTimestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
}